import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-tag',
  imports: [],
  templateUrl: './tag.component.html',
  standalone: true,
  styleUrl: './tag.component.scss'
})
export class TagComponent {
  @Input() text?: string;

}
